const renderErrorModal = ({ message }) => {
  const { title, description } = message;

  const target = document.createElement('div');
  target.setAttribute('id', 'error-modal');
  target.setAttribute('role', 'dialog');

  const htmlString = `
    <div class="fade modal-backdrop error-modal-backdrop in show"></div>
    <div role="dialog" tabindex="-1" class="fade error-modal in show modal">
      <div class="modal-dialog">
        <div class="modal-content" role="document">
          <div class="modal-header">
            <h4 class="modal-title">
              ${title}
            </h4>
            <button type="button" class="close border-0 bg-transparent">
              <span aria-hidden="true">×</span>
              <span class="sr-only visually-hidden">Close</span>
            </button>
          </div>

          <div class="modal-body">
            <p class="text-center">
              ${description}
            </p>
          </div>
          
          <div class="modal-footer">
            <button type="button" class="btn btn-default btn-secondary">Close</button>
          </div>
        </div>
      </div>
    </div>
  `;

  target.innerHTML = htmlString.trim();
  document.body.appendChild(target);

  const $target = $(target);

  $target.find('.error-modal').show();

  $target.find('.close, .modal-footer button').on('click', () => {
    closeModal();
  });

  $target.find('.modal-backdrop').on('click', () => {
    closeModal();
  });

  $target.find('.modal-content').on('click', (event) => {
    event.stopPropagation();
  });

  const closeModal = () => {
    target.remove();
  };
};

export default renderErrorModal;
